import { HttpErrorResponse, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, switchMap, throwError } from 'rxjs';

import { environment } from '../../../environments/environment';
import { AuthStore } from './auth.store';

/** Endpoints publics : jamais de Bearer, jamais de rafraîchissement sur 401. */
const PUBLIC_PATHS = ['/auth/login/', '/auth/otp/resend/', '/web/auth/otp/verify/', '/web/auth/refresh/'];

/** Ajoute le JWT ; sur 401, rafraîchit une fois puis rejoue la requête. */
export const authInterceptor: HttpInterceptorFn = (request, next) => {
  if (!request.url.startsWith(environment.apiUrl) || PUBLIC_PATHS.some((path) => request.url.includes(path))) {
    return next(request);
  }
  const auth = inject(AuthStore);

  return next(withToken(request, auth.access)).pipe(
    catchError((error: unknown) => {
      if (!(error instanceof HttpErrorResponse) || error.status !== 401 || !auth.isLoggedIn()) {
        return throwError(() => error);
      }
      return auth.refresh().pipe(
        catchError((refreshError: unknown) => {
          auth.clear();
          return throwError(() => refreshError);
        }),
        switchMap((access) => next(withToken(request, access))),
      );
    }),
  );
};

function withToken(request: HttpRequest<unknown>, token: string | null): HttpRequest<unknown> {
  return token ? request.clone({ setHeaders: { Authorization: `Bearer ${token}` } }) : request;
}
